import { Controller, useFormContext } from "react-hook-form"
import { FormattedMessage } from "react-intl"
import Select from "@rio-cloud/rio-uikit/Select"
import { volumeUnit } from "@/model/transportation-report/transportation-report"
import NumberInput from "@rio-cloud/rio-uikit/NumberInput"
import { type ShipmentsFormInput } from "./ShipmentPanel"

export const VolumeInput = (props: { shipmentIndex: number }) => {
    const { control, getFieldState, setValue, getValues } = useFormContext<ShipmentsFormInput>()
    const { error } = getFieldState(`shipments.${props.shipmentIndex}.volume`)

    return (
        <Controller<ShipmentsFormInput, `shipments.${number}.volume`> 
            name={`shipments.${props.shipmentIndex}.volume`}
            control={control}
            rules={{
                validate: (value) => {
                    if (!value) return true

                    if (value.unit && !value.value) return "freightPaymentDetails.volume.value.required"

                    if (value.value <= 0) {
                        return "freightPaymentDetails.volume.value.valueMustBeNonNegative"
                    }

                    else return true
                }
            }}
            render={({ field }) => {
                const volume = getValues(`shipments.${props.shipmentIndex}.volume`) 

                const unitSelectName = `${field.name}.unit`
                const valueInputName = `${field.name}.value`

                return (
                    <div className={"display-flex gap-20 margin-bottom-15"}>
                        <div className={"flex-basis-100pct"} data-testid={`SHIPMENT_VOLUME_UNIT_${props.shipmentIndex}`}>
                            <label htmlFor={unitSelectName}>
                                <FormattedMessage id={"shipment.volume.unit"} />
                            </label>
                            <Select
                                value={[volume?.unit || ""]}
                                id={unitSelectName}
                                name={unitSelectName}
                                options={volumeUnit.map(unit => ({
                                    id: unit,
                                    label: <FormattedMessage id={`volume.unit.${unit}`}/>
                                }))}
                                onChange={(selectedOption) => {
                                    if (!selectedOption) {
                                        setValue(
                                            `shipments.${props.shipmentIndex}.volume`,
                                            null,
                                            { shouldValidate: false, shouldDirty: true }
                                        )
                                    } else {
                                        setValue(
                                            `shipments.${props.shipmentIndex}.volume`,
                                            { value: volume?.value || 0, unit: selectedOption?.id },
                                            { shouldValidate: false }
                                        )
                                    }
                                }}
                                useFilter
                                useClear
                            />
                        </div>
                        { volume?.unit ? (
                            <div className={"flex-basis-100pct"}>
                                <div className={`form-group ${error ? "has-error has-feedback" : ""}`}>
                                    <label htmlFor={valueInputName}>
                                        <FormattedMessage id={"shipment.volume"} />
                                    </label>
                                    <NumberInput
                                        value={volume?.value}
                                        id={valueInputName}
                                        name={valueInputName}
                                        min={-Number.MAX_VALUE} // Disabled min by default to 0 so neg. nums can be validated
                                        max={Number.MAX_VALUE}
                                        noDefault
                                        onChange={value => setValue(
                                            `shipments.${props.shipmentIndex}.volume`,
                                            { unit: volume?.unit || "CUBIC_METER", value: value || 0 }
                                        )}
                                    />
                                    <span className={"help-block"}>
                                        {error?.type === "validate" && <FormattedMessage id={error?.message}/>}
                                    </span>
                                    <span className={"form-control-feedback uikit-icon icon-error-sign"} />
                                </div>
                            </div>
                        ) : <div className={"flex-basis-100pct"} />}
                    </div>
                )
            }
            }>
        </Controller>
    )
}
